import React, { PropTypes } from 'react';
import {
  FullScreenEditorHeaderHeight,
  ToolbarWidth,
} from 'shared/constants/FeaturedEditorConstants';
import PrompterRow from 'main/components/show/cuesheet.prompter/prompterRow';

const RowRenderer = ({ index, key, style }, rowProps) => {
  const {
    rowOrder,
    zoomIndex,
    lineHeightIndex,
    zoom,
    lineHeight,
    fontWeight,
    featuredCapitalization,
    prompterTextMirror,
    prompterTextVerticalMirror,
    defaultRTEText,
    width,
    columnId,
    prompterItemInfoEnabled,
    loading,
    onStopEdit,
    onCancelEdit,
    onStartEdit,
    onSelect,
    onBlur,
    scale,
    editorState,
    rowId,
    scrollTop,
    isEditing,
    isSelected,
    item,
    listWidth,
  } = rowProps;

  const itemInfoHeight = _getItemInfoHeight(index);
  const height = style.height || 0;

  let reverseScale = 1 / scale;
  if (reverseScale > 1.5) reverseScale = 1.5;

  let toolbarStyle = {};
  let actionBarStyle = {};
  const scaledHeaderHeight = FullScreenEditorHeaderHeight / scale;
  if (isEditing) {
    const translatePercentage = ((1 - reverseScale) / 2) * -100;
    const scaledToolbarWidth = ToolbarWidth * reverseScale;
    const toolbarGridRatio = scaledToolbarWidth / listWidth;
    const toolbarLeftPercentage = ((toolbarGridRatio - 1) / 2) * -100;

    let headerOffset = Math.max(itemInfoHeight, scaledHeaderHeight);

    let top = scrollTop; // + headerOffset;
    let minTop = style.top + itemInfoHeight;

    if (scrollTop + scaledHeaderHeight > minTop) {
      minTop = scrollTop + scaledHeaderHeight;
    }

    let maxTop = style.top + height - headerOffset * 2;
    if (top < minTop) top = minTop;
    if (top > maxTop) top = maxTop;

    toolbarStyle = {
      top,
      position: 'fixed',
      transform: `translateY(${reverseScale * 100}%) scale(${reverseScale})`,
      'transform-origin': 'left',
      left: `${toolbarLeftPercentage}%`, //this is the toolbar width
    };
    actionBarStyle = {
      top,
      position: 'fixed',
      transform: `translateX(-${translatePercentage}%) translateY(${
        reverseScale * 100
      }%) scale(${reverseScale})`,
      'transform-origin': 'center top',
      right: 0,
    };
  }

  return (
    <div style={style} key={key}>
      <PrompterRow
        height={height}
        viewType="prompter"
        toolbarStyle={toolbarStyle}
        actionBarStyle={actionBarStyle}
        {...{
          index,
          item,
          rowId,
          columnId,
          isEditing,
          isSelected,
          loading,
          prompterItemInfoEnabled,
          editorState,
          defaultRTEText,
          width,
          zoomIndex,
          lineHeightIndex,
          zoom,
          lineHeight,
          fontWeight,
          featuredCapitalization,
          prompterTextMirror,
          prompterTextVerticalMirror,
          onStopEdit,
          onCancelEdit,
          onStartEdit,
          onSelect,
          onBlur,
          reverseScale,
          rowOrder,
        }}
      />
    </div>
  );
};

RowRenderer.propTypes = {
  index: PropTypes.number,
  isScrolling: PropTypes.bool,
  isVisible: PropTypes.bool,
  key: PropTypes.string,
  style: PropTypes.object,
};

function _getItemInfoHeight(index) {
  const itemInfoElement = document.getElementById(
    `featured-fullscreen-editor-row-item-${index}`,
  );
  if (!itemInfoElement) {
    return 0;
  }
  const itemInfoHeight = parseInt(
    window.getComputedStyle(itemInfoElement).height,
    10,
  );
  return itemInfoHeight;
}

export default RowRenderer;
